module.exports = __webpack_public_path__ + "static/_MG_1590-547e7ce7e25c8043f1c44a9317365e19.jpg";